import { Component, FC, ReactNode } from 'react';

interface ErrorBoundaryProps {
	fallback?: FC<{ error?: Error } | Record<string, unknown>>;
	children?: ReactNode;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, { hasError: boolean; error?: Error }> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false, error: undefined };
	}

	componentDidCatch(error: Error) {
		console.error('ErrorBoundary caught an error:', error);
	}

	static getDerivedStateFromError(error: Error) {
		return { hasError: true, error };
	}

	render() {
		if (this.state.hasError) {
			return this.props.fallback ? <this.props.fallback error={this.state.error} /> : null;
		}

		return this.props.children;
	}
}
